import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface InstitucionalItem {
  key: string;
  title: string;
  contentHtml: string;
  version?: string;
}

@Injectable({ providedIn: 'root' })
export class InstitucionalService {
  constructor(private api: ApiService) {}

  list(): Observable<any> {
    return this.api.get('/admin/institucional') as Observable<any>;
  }

  update(key: string, payload: Partial<InstitucionalItem>): Observable<any> {
    return this.api.put(`/admin/institucional/${key}`, payload);
  }
}
